import React from 'react';
import { TInteractiveVote, TVoteRating } from '../../../../store/interactive/types';
import { Button } from '../../../../test/components/ui';

interface Props {
  vote: TInteractiveVote | TVoteRating;
  seconds: number;
  disabled: boolean;
  sendValue: (value: number) => void;
}

export const PollsWithTimer: React.FC<Props> = ({ vote, disabled, seconds, sendValue }) => {
  const [value, setValue] = React.useState(0);

  return (
    <div style={{ padding: '20px 50px' }}>
      <div style={{ width: '100%' }}>
        <div className="tda__wrapper" style={{ width: '100%' }}>
          <div className="tda__testQWrapper" style={{ width: '100%' }}>
            <h5 style={{ display: 'inline-block', margin: '0 20px 20px 0' }}>{vote.title}</h5>
            <div style={{ display: 'inline-block', marginBottom: '20px' }}>Опитування закінчиться через {seconds}</div>
            <ul>
              {vote.questions.map((question) => (
                <li className={value === question.id ? 'tda__active-itm' : ''} key={question.id} onClick={() => setValue(question.id)}>
                  {question.name}
                </li>
              ))}
            </ul>
            <div style={{ textAlign: 'center' }}>
              <Button disabled={disabled} onClick={() => sendValue(value)} title="Відповісти" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
